/**
 * @file ReceiptItemBadges.tsx
 * @description Бейджи строки приёмки: статус этикеток партии и «Срок: не
 * указан» (phase19.22, W17-9c, W20; ui-design §1, §7).
 *
 * Отдельно от списка: одни и те же бейджи стоят в карточке (`<lg`) и в
 * колонке таблицы (`≥lg`), а условие «что показать» не должно расходиться.
 */

import { LabelStatusBadge } from "./labels/LabelStatusBadge";
import { Badge } from "../ui/badge";
import type { LotLabelStatus } from "../../lib/api-labels";

interface Props {
  /** Статус этикеток (только у проведённой приёмки); `undefined` — не показываем. */
  labelStatus?: LotLabelStatus | null;
  printedAt?: string | null;
  missingExpiry: boolean;
  variant?: "card" | "cell";
}

export function ReceiptItemBadges({ labelStatus, printedAt, missingExpiry, variant = "card" }: Props) {
  if (labelStatus === undefined && !missingExpiry) return null;
  return (
    <span className="flex flex-wrap items-center gap-1">
      {labelStatus !== undefined ? (
        <LabelStatusBadge status={labelStatus} printedAt={printedAt} variant={variant} />
      ) : null}
      {missingExpiry ? (
        <Badge variant="warning" className="whitespace-nowrap">
          Срок: не указан
        </Badge>
      ) : null}
    </span>
  );
}
